import {
  FinanceRate,
  getFinanceRateLabel,
} from "@kanda-libs/ks-frontend-services";
import get from "lodash.get";
import { capitaliseWords, formatDecimal } from "common/helpers";
import { ORDER } from "./constants";
import type { Order, RateTableRow, Sorting } from "./types";

export const rateToTableRow = (rate: FinanceRate): RateTableRow => ({
  label: getFinanceRateLabel(rate),
  provider: capitaliseWords(rate.provider),
  apr: `${formatDecimal(rate.apr)}%`,
  fee: formatDecimal(rate.fee),
  apr_type: capitaliseWords(
    rate.apr_type?.replace(/_/g, " ").toLowerCase() || ""
  ),
});

export const sortRates = (
  rates: RateTableRow[],
  sorting: Sorting,
  order: Order
): RateTableRow[] => {
  if (!rates || rates.length === 0) return [];

  return rates.sort((rate1, rate2) => {
    const name1 = get(rate1, sorting);
    const name2 = get(rate2, sorting);
    if (order === ORDER.INVERSE) return (name2 as string)?.localeCompare(name1);
    return name1?.localeCompare(name2);
  });
};
